import { ReactNode } from 'react';
import Sidebar, { NavItem } from './Sidebar';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
  activeItem: NavItem;
  onNavigate: (item: NavItem) => void;
  isAuthenticated: boolean;
  isGuest?: boolean;
  onLogout?: () => void;
  onLoginClick?: () => void;
  showSidebar?: boolean;
  /** When true, render the sidebar as a horizontal top bar instead of left rail. */
  sidebarOnTop?: boolean;
}

export default function Layout({
  children,
  activeItem,
  onNavigate,
  isAuthenticated,
  isGuest,
  onLogout,
  onLoginClick,
  showSidebar = true,
  sidebarOnTop = false,
}: LayoutProps) {
  const layoutClass = [
    'layout',
    showSidebar ? (sidebarOnTop ? 'with-top-sidebar' : 'with-sidebar') : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={layoutClass}>
      {showSidebar && (
        <Sidebar
          activeItem={activeItem}
          onNavigate={onNavigate}
          isAuthenticated={isAuthenticated}
          isGuest={isGuest}
          onLogout={onLogout}
          onLoginClick={onLoginClick}
          horizontal={sidebarOnTop}
        />
      )}
      <main className="layout-content">
        {children}
      </main>
    </div>
  );
}
